import React from 'react';

const TemplateCard = ({ template, onSelect }) => {
  const handleImageError = (e) => {
    // Fallback to a default image if template image fails to load
    e.target.src = '/images/default-template.jpg';
  };

  return (
    <div className="template-card" onClick={onSelect}>
      <div className="template-image">
        <img 
          src={template.image || '/images/default-template.jpg'} 
          alt={template.name}
          onError={handleImageError}
        />
        <div className="template-overlay">
          <span className="template-supplier">{template.supplier}</span>
        </div>
      </div>
      
      <div className="template-content">
        <h4 className="template-name">{template.name}</h4>
        <p className="template-description">{template.description}</p>
        
        <div className="template-category">
          <span className="category-badge">
            {template.category.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())}
          </span>
        </div>
        
        <div className="template-actions">
          <button className="btn btn-primary btn-sm">
            Add to Quote
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
